import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { isPublicNewsEnabled } from "../utility/publicNewsFeature";
import { connect } from "react-redux";
import DefaultLayout from "../layout/default";
const PageLoading = lazy(() => import("../utility/components/PageLoading"));
const Home = lazy(() => import("../modules/frontend/home/pages/home"));
const AboutUs = lazy(() => import("../modules/frontend/aboutUs/pages/aboutUs"));
const ContactUs = lazy(() => import("../modules/frontend/contactUs/pages/contactUs"));
const PrivacyPolicy = lazy(() => import("../modules/frontend/privacyPolicy/pages/privacyPolicy"));
const TermsAndConditions = lazy(() => import("../modules/frontend/termsAndConditions/pages/termsAndConditions"));
const News = lazy(() => import("../modules/frontend/news/pages/news"));
const NewsDetails = lazy(() => import("../modules/frontend/newsDetails/pages/newsDetails"));
const OurTeam = lazy(() => import("../modules/frontend/ourTeam/ourTeam"));
const Memorials = lazy(() => import("../modules/frontend/memorials/pages/memorials"));
const Battalion28Memorial = lazy(() => import("../modules/frontend/memorials/pages/battalion28"));
const Subscription = lazy(() => import("../modules/frontend/subscription/pages/subscription"));
const Login = lazy(() => import("../modules/frontend/login/pages/login"));
const AdminLogin = lazy(() => import("../modules/admin/login/pages/login"));
const ForgotPassword = lazy(() => import("../modules/frontend/forgotPassword/pages/forgotPassword"));
const AdminForgotPassword = lazy(() => import("../modules/admin/forgotPassword/pages/forgotPassword"));
const ResetPassword = lazy(() => import("../modules/frontend/resetPassword/pages/resetPassword"));
const AdminResetPassword = lazy(() => import("../modules/admin/resetPassword/pages/resetPassword"));
const NotFound = lazy(() => import("../modules/frontend/notFound/page/notFound"));

const FrontendRoutes = ({ userData }) => {
    console.log("FrontendRoutes rendering, userData:", userData);
    console.log("Current path:", window.location.hash);

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering Home")}
                            <Home />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/aboutUs"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering AboutUs")}
                            <AboutUs />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/contactUs"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering ContactUs")}
                            <ContactUs />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/privacyPolicy"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering PrivacyPolicy")}
                            <PrivacyPolicy />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/termsAndConditions"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering TermsAndConditions")}
                            <TermsAndConditions />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/subscriptions"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering Subscription")}
                            <Subscription />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/ourTeam"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering OurTeam")}
                            <OurTeam />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/memorials"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering Memorials")}
                            <Memorials />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/memorials/battalion-28"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            <Battalion28Memorial />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/newsDetails/:slug?"
                element={
                    isPublicNewsEnabled ? (
                        <DefaultLayout>
                            <Suspense fallback={<PageLoading />}>
                                {console.log("Rendering NewsDetails")}
                                <NewsDetails />
                            </Suspense>
                        </DefaultLayout>
                    ) : (
                        <Navigate to="/" replace />
                    )
                }
            />
            <Route
                path="/latestnews"
                element={
                    isPublicNewsEnabled ? (
                        <DefaultLayout>
                            <Suspense fallback={<PageLoading />}>
                                {console.log("Rendering News")}
                                <News />
                            </Suspense>
                        </DefaultLayout>
                    ) : (
                        <Navigate to="/" replace />
                    )
                }
            />
            <Route
                path="/login"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering Login")}
                            <Login />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/forgotPassword"
                element={
                    <DefaultLayout>
                        <Suspense fallback={<PageLoading />}>
                            {console.log("Rendering ForgotPassword")}
                            <ForgotPassword />
                        </Suspense>
                    </DefaultLayout>
                }
            />
            <Route
                path="/reset-password/:token"
                element={
                    <Suspense fallback={<PageLoading />}>
                        {console.log("Rendering ResetPassword")}
                        <ResetPassword />
                    </Suspense>
                }
            />
            <Route
                path="/admin/login"
                element={
                    <Suspense fallback={<PageLoading />}>
                        {console.log("Rendering AdminLogin")}
                        <AdminLogin />
                    </Suspense>
                }
            />
            <Route
                path="/admin/forgotPassword"
                element={
                    <Suspense fallback={<PageLoading />}>
                        {console.log("Rendering AdminForgotPassword")}
                        <AdminForgotPassword />
                    </Suspense>
                }
            />
            <Route
                path="/admin/reset-password/:token"
                element={
                    <Suspense fallback={<PageLoading />}>
                        {console.log("Rendering AdminResetPassword")}
                        <AdminResetPassword />
                    </Suspense>
                }
            />
            <Route
                path="*"
                element={
                    <Suspense fallback={<PageLoading />}>
                        {console.log("Rendering NotFound")}
                        <NotFound />
                    </Suspense>
                }
            />
        </Routes>
    );
};

const mapStateToProps = (globalState) => ({
    userData: globalState.mainReducerData.userData,
});

export default connect(mapStateToProps, {})(FrontendRoutes);
